import { createUseStyles, useTheme } from "react-jss"
import { useAppSelector } from "../util/hooks"
import { gantSelectionLabelSelector } from "../features/Monitor/MonitorSlice"

const useStyles = createUseStyles({
  container: {
    display: "inline-flex",
    padding: "4px 12px",
    justifyContent: "center",
    alignItems: "center",
    gap: "6px",
    borderRadius: "8px",
    border: "1px solid rgba(0, 0, 0, 0.50)",
    background: "#FFF",
    color: "#000",
    fontFamily: ({ theme }: any) => theme.primaryFontFamily,
    fontSize: "10px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "132%",
  },
})

export default function CustomChip(props: any) {
  const name = useAppSelector(gantSelectionLabelSelector)

  const theme: any = useTheme()
  const classes = useStyles({ ...props, theme })
  const selectedRunId = useAppSelector(
    (store) =>
      store.monitor.pipelineRunDialog?.selectedRunDetails?.az_pipeline_run_id,
  )
  return name.length ? (
    <>
      <div className={classes.container}>{name}</div>
      <div className={classes.container}>{selectedRunId}</div>
    </>
  ) : (
    ""
  )
}
